import Page from 'components/pages/referral-code'

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking'
  }
}

export async function getStaticProps({ params }) {
  try {
    const code = params.code
    const { name } = await fetchCodeInfo(code)
    return { props: { name, code } }
  } catch (error) {
    if (error.code === 'referral.invlidReferralCode') return { notFound: true }
    throw error
  }
}

export default function ReferralCode({ name, code }) {
  const Context = ctx('referralCode')
  return (
    <Context.Provider value={ { name, code } }>
      <Page />
    </Context.Provider>
  )
}

const fetchCodeInfo = async code => {
  const query = `
    query ($code: String!) {
      referralCodeInfo(code: $code) {
        name
      }
    }
  `
  const { referralCodeInfo } = await request(query, { code })
  return referralCodeInfo
}
